<template>
  <div class="investors-fs">
    <p class="indent">ALCOMET AD is a public company whose shares are traded on the Bulgarian Stock Exchange. According to the Law on Public Offering of Securities, the company regularly reveals financial and other information to the Financial Supervision Commission, to the Bulgarian Stock Exchange and to the public. </p>
    <p class="indent">Quarterly and annual financial reports are prepared in accordance with the International accounting standards and verified by independent auditors.</p>
    <p class="indent">Here you can download our latest financial reports.</p>

    <p>
      <a href="/static/files/reports/Alcomet-AD-2019-Financial-statements.pdf" target="_blank">Alcomet AD 2019 - Financial statements</a>
    </p>
    <p>
      <a href="/static/files/reports/Alcomet-AD-2018-Financial-statements.pdf" target="_blank">Alcomet AD 2018 - Financial statements</a>
    </p>
    <p>
      <a href="/static/files/reports/Alcomet-AD-2017-financial-statements.pdf" target="_blank">Alcomet AD 2017 - Financial statements</a>
    </p>
    <p>
      <a href="/static/files/reports/Alcomet-AD-2016-Financial-statements.pdf" target="_blank">Alcomet AD 2016 - Financial statements</a>
    </p>
    <p>
      <a href="/static/files/reports/Alcomet-AD-2015-Financial-statements.pdf" target="_blank">Alcomet AD 2015 - Financial statements</a>
    </p>
    <p>
      <a href="/static/files/reports/Alcomet-AD-2014-ENG-financial-statements.pdf" target="_blank">Alcomet AD 2014 - Financial statements</a>
    </p>
    <p>
      <a href="/static/files/reports/Alcomet-AD-2013-ENG-f.pdf" target="_blank">Management report and Financial statements for 2013</a>
    </p>
    <p>
      <a href="/static/files/reports/Alcomet-AD-2012-ENG-FS.pdf" target="_blank">Management report for 2012</a>
    </p>
    <p>
      <a href="/static/files/reports/Alcomet-AD_Man.Report-2012-EN.pdf" target="_blank">Financial statements for 2012</a>
    </p>
    <p>
      <a href="/static/files/reports/Alcomet-AD-2011-Management-Report-EN.pdf">Management Report for 2011</a>
    </p>
    <p>
      <a href="/static/files/reports/Alcomet-AD-2011-FS_AR_ENG.pdf">Financial statements for 2011</a>
    </p>
    <app-share-button></app-share-button>
  </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
export default {
  components: {
    appShareButton: ShareButton
  }
};
</script>

<style scoped>
.investors-fs > p {
  font-size: 19px;
  line-height: 32px;
  margin: 15px auto;
  text-align: justify;
  width: 60%;
}
a {
  text-decoration: underline;
}
@media screen and (max-width: 1000px) {
  .investors-fs > p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/investors/FinancialStatements.vue